module.exports = __webpack_public_path__ + "static/quiz2_2-94a090933f78c62c61d00b5ab0daf3cd.png";